import { DataBean } from "../DataBean";

export class SalesOrderItem extends DataBean {

    public async deleteSalesOrderItem(salesOrderDate: any,idSalesOrderItem: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSalesOrderItem_java.util.Date_Number", [salesOrderDate, idSalesOrderItem]);
    }

    public async getSalesOrderItem(idSalesOrderItem: number, salesOrderDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.sales.SalesOrderItem_getSalesOrderItem_Number_java.util.Date", [idSalesOrderItem, salesOrderDate]);
    }

    public async getSalesOrderItemCatalog(idSalesOrder: number, salesOrderDate: any, idProduct: number, regexStr: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getSalesOrderItemCatalog_Number_java.util.Date_Number_String_Number_Number", [idSalesOrder, salesOrderDate, idProduct, regexStr, page, recordsPerPage]);
    }

    public async updateSalesOrderItem(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.sales.SalesOrderItem_updateSalesOrderItem_com.quickdataerp.bean.sales.SalesOrderItem", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.sales.SalesOrderItem"
            }
        ]);
    }

}
